import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OperationsService {
  constructor(private http: HttpClient) {}

  crearOperacion(operacion: any) {
    console.log('operacion:', operacion);
    return this.http.post(`${environment.backendApiUrl}/operations`, operacion);
  }
  actualizarOperacion(id: string, operacion: any) {
    return this.http.put(`${environment.backendApiUrl}/operations/${id}`, operacion);
  }
  
  actualizarCampoOperacion(id: number, campo: string, valor: any) {
    return this.http.put(`${environment.backendApiUrl}/operations/${id}`, { [campo]: valor });
  }

  obtenerOperacion(id: number) {
    return this.http.get(`${environment.backendApiUrl}/operations/${id}`);
  }
  obtenerOperaciones(page: number = 1, pageSize: number = 10) {
    return this.http.get(`${environment.backendApiUrl}/operations/?page=${page}&limit=${pageSize}`);
  }
  enviarBoletosPorEmail(id: number): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/operations/${id}/tickets/email`, {});
  }
  enviarBoletosPorEmailOtroMail(id: number, email: string): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/operations/${id}/tickets/email`, { email });
  }
  devolverBoleto(id: number, ticketId: number): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/operations/${id}/tickets/${ticketId}/refund`, {});
  }
  devolverTodosLosBoletos(id: number): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/operations/${id}/refund`, {});
  }
}